import axios from 'axios';
import { API_URL, BEARER, PROJECT } from './config';

export default axios.create({
  baseURL: `${API_URL}/${PROJECT}`,
  headers: {
    Authorization: `Bearer ${BEARER}`,
  },
});
